//import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
//import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { PrimengComponentsModule } from './primeng.module';
import { UserService } from './services/user.service';
import { LoginComponent } from './components/login/login.component';
import { HeaderComponent } from './components/header/header.component';
import { HeaderService } from './components/header/header.service';
import { FooterComponent } from './components/footer/footer.component';
import { LoginService } from './components/login/login.service';
import { HttpWrapperService } from './services/http-wrapper.service';
import { SafeUrlPipe } from './pipe/safe-url.pipe';
import { SearchTableComponent } from './components/search-table/search-table.component';
import { FilterTableComponent } from './components/filter-table/filter-table.component';
import { AuthGuard } from './auth/auth.guard';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { ToNumberPipe } from './pipe/to-number.pipe';
import { HelpComponent } from './components/help/help.component';
import { DisplayDatePipe } from './pipe/display-date.pipe';
import { DatePipe } from '@angular/common';
import { LoginAuthComponent } from './components/login-auth/login-auth.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { TealiumUtagService } from '../assets/ts/utag.service';
import { TagsService } from './services/tags.service';
import { IconsWidget } from './components/icons/icons.widget';
import { DvpsCoreRoutingModule } from './dvps-core.routing.module';
import { CommonService } from './services/common.service';

@NgModule({
  declarations: [
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    SafeUrlPipe,
    SearchTableComponent,
    FilterTableComponent,
    ClickOutsideDirective,
    ToNumberPipe,
    HelpComponent,
    DisplayDatePipe,
    LoginAuthComponent,
    PaginationComponent,
    IconsWidget
  ],
  imports: [
    //BrowserModule,
    //BrowserAnimationsModule,
    //HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,

    PrimengComponentsModule,
    DvpsCoreRoutingModule,
  ],
  exports: [
    PrimengComponentsModule,

    LoginComponent,
    HeaderComponent,
    FooterComponent,
    SafeUrlPipe,
    SearchTableComponent,
    FilterTableComponent,
    ClickOutsideDirective,
    ToNumberPipe,
    HelpComponent,
    DisplayDatePipe,
    LoginAuthComponent,
    PaginationComponent,
    IconsWidget
  ],
  // providers: [
  //   UserService,
  //   LoginService,
  //   HttpWrapperService,
  //   AuthGuard,
  //   DatePipe,
  //   HeaderService,
  //   TealiumUtagService,
  //   TagsService,
  //   CommonService
  // ],
  bootstrap: []
})
//export class DvpsCoreModule { }//RouterModule.forRoot([])
export class DvpsCoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: DvpsCoreModule,
      providers: [
        UserService,
        LoginService,
        HttpWrapperService,
        AuthGuard,
        DatePipe,
        HeaderService,
        TealiumUtagService,
        TagsService,
        CommonService
      ]
    };
  }
}